module.exports = __webpack_public_path__ + "static/media/214x152_3 copy.b105a14b.png";